import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";

type Options = {
    value: string;
    canSubmit?: boolean;
    onSubmit: (value: string, e?: React.KeyboardEvent<HTMLTextAreaElement>) => void;
    onBeforeSubmit?: () => void;
};

export function usePromptHandlers({ value, canSubmit = true, onSubmit, onBeforeSubmit }: Options) {
    const navigate = useNavigate();

    const setNewQueryInUrl = (newQuery: string) => {
        const searchParams = new URLSearchParams(location.search);
        if (newQuery) {
            searchParams.set("q", newQuery);
        }
        const queryString = searchParams.toString();
        return queryString ? queryString : null;
    };

    const submit = useCallback(
        (e?: React.KeyboardEvent<HTMLTextAreaElement>) => {
            if (!canSubmit) return;
            const v = value.trim();
            if (v.length < 1) return;
            onBeforeSubmit?.();
            onSubmit(v, e);
            navigate(`${location.pathname}?${setNewQueryInUrl(v)}`, { replace: true });
        },
        [canSubmit, value, onBeforeSubmit, onSubmit]
    );

    const handleKeyDown = useCallback(
        (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
            if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                submit(e);
            }
        },
        [submit]
    );

    return { submit, handleKeyDown };
}